import React, { useState } from 'react';
import GradPackageTable from '../hs-grad/gradPackageTable';
import GradPackageOverview from '../hs-grad/gradPackageOverview';

const tabTypes = ['Overview', 'Compare'];

const GradPackageTabs = ({
    packageList, 
    productList, 
    pageContentData, 
    hsPaymentPromo,
    altImage, 
    fromGradPackages, 
    isDegreeSelected 
}) => {
    const [active, setActive] = useState(tabTypes[0]);

    const setActiveTab = (e, tabType) => {
        e.preventDefault();
        setActive(tabType);
    }
    
    const preparedProductList = [...productList]
    const mostPopularPackageIdx = preparedProductList.findIndex(pkgProduct => pkgProduct.mostPopular)
    if (mostPopularPackageIdx > 0) {
        // push most popular package to the top
        const mostPopularPackage = preparedProductList[mostPopularPackageIdx]
        preparedProductList.splice(mostPopularPackageIdx, 1)
        preparedProductList.splice(0, 0, mostPopularPackage)
    }

    const gradPackageOverviewComponetn = (<GradPackageOverview 
        packageList={packageList} 
        productList={preparedProductList} 
        hsPaymentPromo={hsPaymentPromo} 
        fromGradPackages={fromGradPackages}
        altImage={altImage} 
    />)
    
    const gradPackageTableComponetn = (<GradPackageTable
        packageList={packageList} 
        productList={preparedProductList} 
        pageContentData={pageContentData} 
        fromGradPackages={fromGradPackages} 
        altImage={altImage}
    />)

    return (
        <>
            { isDegreeSelected &&
                packageList?.length > 0 && 
                <div className='container-fluid mt-5'>
                    <h4 className='pb-3 group-name'>
                        {pageContentData?.title}
                        <span className="ml-2 pl-2 group-description">{pageContentData?.shortDescription}</span>
                    </h4>

                    <ul className="nav nav-tabs package-tabs">
                        {tabTypes.map(type => (
                            <li className="nav-item" key={type}>
                                <a className={`nav-link ${type === active ? 'active':''}`} onClick={(e) => setActiveTab(e, type)} href="#">{type}</a>
                            </li>
                        ))}
                    </ul>

                    <div className="package-tabs-content">
                        {
                            {
                                'Overview': gradPackageOverviewComponetn,
                                'Compare': gradPackageTableComponetn
                            }[active]
                        }
                    </div>
                </div>
            }
        </>
    );
}

export default GradPackageTabs;